import { apiEmployeeDocument } from "@/api/employees/employee-document.api.ts";
import { ApiErrorException, ApiPassException } from "@/types/api.types.ts";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useQuery } from "@tanstack/react-query";

export const employeeDocumentsKeys = createQueryKeys("employeeDocuments", {
  folders: (employeeId: number | undefined) => ({
    queryKey: [employeeId],
    queryFn: async ({ signal }) => {
      if (!employeeId) throw new ApiPassException("employeeId is required");
      const result = await apiEmployeeDocument.getAllFolders(employeeId, signal);
      if (result.error) throw new ApiErrorException(result.error);
      return result.data;
    },
  }),
});

export const useEmployeeDocumentsFolders = (employeeId?: number, enabled = true) => {
  return useQuery({
    ...employeeDocumentsKeys.folders(employeeId),
    enabled: !!employeeId && enabled,
  });
};
